<template>
  <div v-if="isOpen" class="modal-overlay" @click.self="closeModal">
    <div class="modal-container">
      <div class="modal-header">
        <h3 class="modal-title">
          <i class="fas fa-download"></i>
          Exportar Histórico de Perfis
        </h3>
        <button class="modal-close" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label class="form-label">Data Início</label>
          <input 
            type="date" 
            v-model="selectedStartDate" 
            class="form-input"
            :max="selectedEndDate"
          />
        </div>

        <div class="form-group">
          <label class="form-label">Data Fim</label>
          <input 
            type="date" 
            v-model="selectedEndDate" 
            class="form-input"
            :min="selectedStartDate"
            :max="todayDate"
          />
        </div>

        <div class="form-group">
          <label class="form-label">Tipo de arquivo</label>
          <div class="file-type-options">
            <button 
              type="button"
              class="file-type-btn"
              :class="{ selected: selectedFormat === 'excel' }"
              @click="selectedFormat = 'excel'"
            >
              <i class="fas fa-file-excel"></i>
              <span>Excel</span>
            </button>
            <button 
              type="button"
              class="file-type-btn"
              :class="{ selected: selectedFormat === 'pdf' }"
              @click="selectedFormat = 'pdf'"
            >
              <i class="fas fa-file-pdf"></i>
              <span>PDF</span>
            </button>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button 
          class="btn-confirm" 
          @click="confirmDownload"
          :disabled="loading || !selectedStartDate || !selectedEndDate"
          type="button"
        >
          <i :class="loading ? 'fas fa-spinner fa-spin' : 'fas fa-download'"></i>
          {{ loading ? 'Gerando...' : 'Baixar' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { format, subDays } from 'date-fns';

export default {
  name: 'ExportProfileModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    initialTab: {
      type: String,
      default: 'history'
    },
    singleTab: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedStartDate: '',
      selectedEndDate: '',
      selectedFormat: 'excel',
      todayDate: format(new Date(), 'yyyy-MM-dd')
    }
  },
  watch: {
    isOpen(newValue) {
      if (newValue) {
        this.initializeDates();
      }
    }
  },
  methods: {
    initializeDates() {
      const today = new Date();
      this.selectedEndDate = format(today, 'yyyy-MM-dd');
      this.selectedStartDate = format(subDays(new Date(), 30), 'yyyy-MM-dd');
      this.selectedFormat = 'excel';
    },

    closeModal() {
      this.$emit('close');
    },

    confirmDownload() {
      if (!this.selectedStartDate || !this.selectedEndDate) {
        alert('Por favor, selecione ambas as datas');
        return;
      }

      const exportType = this.singleTab || this.initialTab || 'history';
      this.$emit('confirm', {
        type: exportType,
        startDate: this.selectedStartDate,
        endDate: this.selectedEndDate,
        format: this.selectedFormat
      });
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.modal-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 500px;
  overflow: hidden;
}

.modal-header {
  background-color: #1b4238;
  color: white;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}

.modal-close {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
}

.modal-close:hover {
  opacity: 0.8;
}

.modal-body {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #1b4238;
  box-shadow: 0 0 0 3px rgba(27, 66, 56, 0.1);
}

.file-type-options {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.file-type-btn {
  flex: 1;
  min-width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.2s;
}

.file-type-btn:hover {
  border-color: #1b4238;
  background-color: #f8faf8;
}

.file-type-btn.selected {
  border-color: #1b4238;
  background-color: #e8f5e9;
  color: #1b4238;
}

.file-type-btn i {
  font-size: 24px;
}

.file-type-btn:first-child i {
  color: #28a745;
}

.file-type-btn:last-child i {
  color: #dc3545;
}

.modal-footer {
  padding: 16px 24px;
  background-color: #f9fafb;
  display: flex;
  justify-content: flex-end;
}

.btn-confirm {
  background-color: #1b4238;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  text-transform: uppercase;
}

.btn-confirm:hover:not(:disabled) {
  background-color: #1e7e34;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-confirm:active:not(:disabled) {
  transform: translateY(0);
}

.btn-confirm:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}

@media screen and (max-width: 600px) {
  .modal-container {
    margin: 20px;
  }

  .modal-body {
    padding: 20px;
  }
}
</style>
